import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBox, FiUser, FiMoon, FiSun } = FiIcons;

const Header = ({ isDark, toggleTheme }) => {
  return (
    <header className="bg-white/80 dark:bg-[#0A0A0A]/80 backdrop-blur-md border-b border-gray-100 dark:border-gray-800 py-4 px-6 md:px-12 sticky top-0 z-50 transition-colors duration-300">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 text-gray-900 dark:text-white hover:text-gray-600 dark:hover:text-gray-300 transition-colors">
          <SafeIcon icon={FiBox} className="text-xl" />
          <span className="font-medium text-lg tracking-tight">Inventry</span>
        </Link>
        
        <div className="flex items-center gap-4">
          <button 
            onClick={toggleTheme}
            className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-500 dark:text-gray-400 transition-all active:scale-95"
            aria-label="Toggle theme"
          >
            <SafeIcon icon={isDark ? FiSun : FiMoon} className="text-lg" />
          </button>
          
          <div className="h-8 w-8 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-500 dark:text-gray-400">
            <SafeIcon icon={FiUser} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;